import React, { useState, useEffect } from "react";
import { Table, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const PRPopUpDetailsForSteel = ({ prData }) => {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState([]);
  const [materialSizes, setMaterialSizes] = useState([]);
  const [diameterPrices, setDiameterPrices] = useState({});
  // useEffect(() => {
  //   if (prData) {
  //     const sizes = new Set();
  //     const priceMap = {};
  //     prData.forEach((city) => {
  //       city.site_wise_pr.forEach((site) => {
  //         site.pr_material_details.forEach((material) => {
  //           material.steel_sizes.forEach((size) => {
  //             sizes.add(size.value);
  //             if (priceMap[size.value] === undefined) {
  //               priceMap[size.value] = size.estimated_price;
  //             }
  //           });
  //         });
  //       });
  //     });

  //     const sortedSizes = Array.from(sizes).sort((a, b) => a - b);
  //     setMaterialSizes(sortedSizes);
  //     setDiameterPrices(priceMap);
  //     const transformedData = [];
  //     let rowCounter = 1;
  //     let grandTotalEstimatedAmount = 0;
  //     prData.forEach((city, cityIndex) => {
  //       let cityTotalEstimatedAmount = 0;
  //       city.site_wise_pr.forEach((site, siteIndex) => {
  //         let siteTotalEstimatedAmount = 0;
  //         site.pr_material_details.forEach((material, materialIndex) => {
  //           const diameterMap = {};
  //           material.steel_sizes.forEach((size) => {
  //             diameterMap[size.value] = {
  //               quantity: size.quantity,
  //               price: size.estimated_price,
  //             };
  //           });

  //           const estimatedAmount = material.steel_sizes.reduce(
  //             (sum, size) =>
  //               sum +
  //               (material.pr_material_type_uom_name === "MT"
  //                 ? size.quantity * 1000 * size.estimated_price
  //                 : size.quantity * size.estimated_price),
  //             0
  //           );

  //           siteTotalEstimatedAmount += estimatedAmount;
  //           cityTotalEstimatedAmount += estimatedAmount;
  //           grandTotalEstimatedAmount += estimatedAmount;

  //           transformedData.push({
  //             key: `${cityIndex}-${siteIndex}-${materialIndex}`,
  //             srNo: siteIndex === 0 && materialIndex === 0 ? rowCounter : null,
  //             city: city.city_name,
  //             site: site.site_name,
  //             materialType: material.pr_material_type_name,
  //             pr_material_type_sub_category: materialIndex === 0 && material.pr_material_type_sub_category,
  //             uom: material.pr_material_type_uom_name,
  //             totalQtyKg: material.pr_material_type_quantity_by_kg,
  //             estimatedAmount,
  //             remark: material.remark,
  //             diameters: diameterMap,
  //             isFirstInCity: siteIndex === 0 && materialIndex === 0,
  //             isFirstInSite: materialIndex === 0,
  //             rowType: "material",
  //           });
  //         });

  //         transformedData.push({
  //           key: `${cityIndex}-${siteIndex}-subtotal`,
  //           city: city.city_name,
  //           site: `Sub Total for ${site.site_name} site`,
  //           totalQtyKg: site.site_total_quantity_by_kg,
  //           estimatedAmount: siteTotalEstimatedAmount,
  //           rowType: "siteSubTotal",
  //         });
  //       });

  //       transformedData.push({
  //         key: `${cityIndex}-total`,
  //         city: `City Total - ${city.city_name}`,
  //         totalQtyKg: city.city_total_quantity_by_kg,
  //         estimatedAmount: cityTotalEstimatedAmount,
  //         rowType: "cityTotal",
  //       });
  //           rowCounter++;

  //     });

  //     transformedData.push({
  //       key: "grand-total",
  //       city: "Total",
  //       totalQtyKg: prData.reduce(
  //         (sum, city) => sum + city.city_total_quantity_by_kg,
  //         0
  //       ),
  //       estimatedAmount: grandTotalEstimatedAmount,
  //       rowType: "grandTotal",
  //     });

  //     setTableData(transformedData);
  //   }
  // }, [prData]);

    useEffect(() => {
    if (prData) {
      const sizes = new Set();
      const priceMap = {};
      prData.forEach((city) => {
        city.site_wise_pr.forEach((site) => {
          site.pr_material_details.forEach((material) => {
            material.steel_sizes.forEach((size) => {
              sizes.add(size.value);
              if (priceMap[size.value] === undefined) {
                priceMap[size.value] = size.estimated_price;
              }
            });
          });
        });
      });

      const sortedSizes = Array.from(sizes).sort((a, b) => a - b);
      setMaterialSizes(sortedSizes);
      setDiameterPrices(priceMap);

      const transformedData = [];
      let rowCounter = 1;
      let grandTotalEstimatedAmount = 0;

      prData.forEach((city, cityIndex) => {
        let cityTotalEstimatedAmount = 0;
        city.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotalEstimatedAmount = 0;
          const seenSubCategories = new Set(); // Track sub-categories within this site

          site.pr_material_details.forEach((material, materialIndex) => {
            const diameterMap = {};
            material.steel_sizes.forEach((size) => {
              diameterMap[size.value] = {
                quantity: size.quantity,
                price: size.estimated_price,
              };
            });

            const estimatedAmount = material.steel_sizes.reduce(
              (sum, size) =>
                sum +
                (material.pr_material_type_uom_name === "MT"
                  ? size.quantity * 1000 * size.estimated_price
                  : size.quantity * size.estimated_price),
              0
            );

            siteTotalEstimatedAmount += estimatedAmount;
            cityTotalEstimatedAmount += estimatedAmount;
            grandTotalEstimatedAmount += estimatedAmount;

            // Only show sub-category if it's the first occurrence in this site
            const subCategory = material.pr_material_type_sub_category;
            const showSubCategory = !seenSubCategories.has(subCategory);
            seenSubCategories.add(subCategory);

            transformedData.push({
              key: `${cityIndex}-${siteIndex}-${materialIndex}`,
              srNo: siteIndex === 0 && materialIndex === 0 ? rowCounter : null,
              city: city.city_name,
              site: site.site_name,
              materialType: material.pr_material_type_name,
              pr_material_type_sub_category: showSubCategory ? subCategory : "", // Show only if new sub-category
              uom: material.pr_material_type_uom_name,
              totalQtyKg: material.pr_material_type_quantity_by_kg,
              estimatedAmount,
              remark: material.remark,
              diameters: diameterMap,
              isFirstInCity: siteIndex === 0 && materialIndex === 0,
              isFirstInSite: materialIndex === 0,
              rowType: "material",
            });
          });

          transformedData.push({
            key: `${cityIndex}-${siteIndex}-subtotal`,
            city: city.city_name,
            site: `Sub Total for ${site.site_name} site`,
            totalQtyKg: site.site_total_quantity_by_kg,
            estimatedAmount: siteTotalEstimatedAmount,
            rowType: "siteSubTotal",
          });
        });

        transformedData.push({
          key: `${cityIndex}-total`,
          city: `City Total - ${city.city_name}`,
          totalQtyKg: city.city_total_quantity_by_kg,
          estimatedAmount: cityTotalEstimatedAmount,
          rowType: "cityTotal",
        });
        rowCounter++;
      });

      transformedData.push({
        key: "grand-total",
        city: "Total",
        totalQtyKg: prData.reduce(
          (sum, city) => sum + city.city_total_quantity_by_kg,
          0
        ),
        estimatedAmount: grandTotalEstimatedAmount,
        rowType: "grandTotal",
      });

      setTableData(transformedData);
    }
  }, [prData]);
  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      width: 50,
      align: "center",
      render: (text, record) => {
        if (record.isFirstInCity) {
          return text;
        }
        return "";
      },
    },
    {
      title: "City",
      dataIndex: "city",
      width: 120,
      render: (text, record) => {
        if (
          record.rowType === "siteSubTotal" ||
          record.rowType === "cityTotal" ||
          record.rowType === "grandTotal"
        ) {
          return "";
        }
        if (record.rowType === "material" && !record.isFirstInCity) {
          return "";
        }
        return text;
      },
    },
    {
      title: "Site",
      dataIndex: "site",
      width: 120,
      render: (text, record) => {
        if (record.rowType === "grandTotal") {
          return <div className="totalCityOverallSitee5">Total</div>;
        }
        if (record.rowType === "cityTotal") {
          return <div className="citytotal">City Total</div>;
        }
        if (record.rowType === "siteSubTotal") {
          return <div className="subtotal">Sub Total</div>;
        }
        if (record.rowType === "material" && !record.isFirstInSite) {
          return "";
        }
        return text;
      },
    },
     {
      title: "Sub category",
      dataIndex: "pr_material_type_sub_category",
      width: 100,
      render: (text, record) => {
        if (
          ["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)
        ) {
          return "";
        }
        return text;
      },
    },
    {
      title: "Grade & Quality",
      dataIndex: "materialType",
      width: 140,
      render: (text, record) => {
        if (
          ["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)
        ) {
          return "";
        }
        return text;
      },
    },
    ...materialSizes.map((size) => ({
      title: <span>{size} MM </span>,
      dataIndex: "diameters",
      width: 60,
      align: "center",
      render: (diameters, record) => {
        if (
          ["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)
        ) {
          return "";
        }
        return diameters[size]?.quantity || "";
      },
    })),
    {
      title: <Tooltip title="Total Quantity in Kilograms">Qty. in Kg</Tooltip>,
      dataIndex: "totalQtyKg",
      width: 100,
      align: "right",
      render: (text, record) => {
        if (
          record.rowType === "siteSubTotal" ||
          record.rowType === "cityTotal" ||
          record.rowType === "grandTotal"
        ) {
          return "";
        }
        return (
          text?.toLocaleString("en-IN", { maximumFractionDigits: 0 }) || ""
        );
      },
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      width: 80,
      align: "center",
      render: (text, record) => {
        if (
          ["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)
        ) {
          return "";
        }
        return text;
      },
    },
    {
      title: <Tooltip title="Estimated Amount">Est. Amount</Tooltip>,
      dataIndex: "estimatedAmount",
      width: 120,
      align: "right",
      render: (text, record) => {
        if (record.rowType === "material") {
          return `₹ ${text?.toLocaleString("en-IN", {
            maximumFractionDigits: 0,
          })}`;
        }
        if (record.rowType === "siteSubTotal") {
          return (
            <div
              style={{ width: "100% !important", textAlign: " -webkit-right" }}
            >
              <div className="subtotal">
                ₹ {text.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
              </div>
            </div>
          );
        }
        if (record.rowType === "cityTotal") {
          return (
            <div style={{ width: "100%", textAlign: " -webkit-right" }}>
              <div className="citytotal">
                ₹ {text.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
              </div>
            </div>
          );
        }
        if (record.rowType === "grandTotal") {
          return (
            <div style={{ width: "100%", textAlign: " -webkit-right" }}>
              <div className="totalCityOverallSitee5">
                ₹ {text.toLocaleString("en-IN", { maximumFractionDigits: 0 })}
              </div>
            </div>
          );
        }
        return "";
      },
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      width: 150,
      render: (text, record) => {
        if (
          ["siteSubTotal", "cityTotal", "grandTotal"].includes(record.rowType)
        ) {
          return "";
        }
        return text || "";
      },
    },
  ];


  return (
    <Table
      columns={columns}
      dataSource={tableData}
      pagination={false}
      bordered
      rowClassName={(record) => {
        if (record.rowType === "siteSubTotal") return "site-subtotal-row";
        if (record.rowType === "cityTotal") return "city-total-row";
        if (record.rowType === "grandTotal") return "grand-total-row";
        return "";
      }}
    />
  );
};

PRPopUpDetailsForSteel.propTypes = {
  prData: PropTypes.func,
};

export default PRPopUpDetailsForSteel;
